import { render, staticRenderFns } from "./Asset-chart.vue?vue&type=template&id=08e026f0&scoped=true&"
import script from "./Asset-chart.vue?vue&type=script&lang=js&"
export * from "./Asset-chart.vue?vue&type=script&lang=js&"
import style0 from "./Asset-chart.vue?vue&type=style&index=0&id=08e026f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e026f0",
  null
  
)

export default component.exports